<template>
  <div>
    <Card class="px-1 w-full my-auto" pt:content:class="p-0!">
      <template #content>
        <div class="flex gap-2 justify-center">
          <Select
            v-model="selectedTemplate"
            :options="templates"
            optionLabel="name"
            placeholder="Select a template"
            class="max-w-96 w-full h-10"
            scroll-height="30rem"
            @change="emit('templateChanged')"
          >
            <template #option="slotProps">
              <div class="flex align-items-center">
                <div class="me-2">{{ slotProps.option.name }}</div>
                <i v-if="slotProps.option.defaultTemplate" class="pi pi-star"></i>
              </div>
            </template>
          </Select>
          <IconButton v-tooltip.top="'Save'" icon="save" :disabled="!selectedTemplate" @click="emit('saveTemplate')"></IconButton>
          <IconButton
            v-tooltip.top="'Delete'"
            icon="trash"
            severity="danger"
            :disabled="!selectedTemplate"
            @click="emit('deleteTemplate')"
          ></IconButton>
          <IconButton v-tooltip.top="'Default'" icon="star" severity="info" :disabled="!selectedTemplate" @click="emit('setDefault')"></IconButton>
          <IconButton v-tooltip.top="'New'" icon="plus" severity="success" :disabled="!selectedTemplate" @click="addTemplate = true"></IconButton>
        </div>
        <Fieldset legend="Column Selection" class="w-full">
          <PickList
            v-model="options"
            :show-source-controls="false"
            :show-target-controls="false"
            scrollHeight="50vh"
            @selection-change="emit('optionsChanged')"
          >
            <template #sourceheader> <span class="font-bold"> Excluded </span> </template>
            <template #targetheader> <span class="font-bold"> Included</span> </template>
            <template #option="slotProps">
              <span>{{ slotProps.option.label }}</span>
            </template>
          </PickList>
        </Fieldset>
        <div v-if="props.modal" class="flex justify-end gap-2 mt-2">
          <SubmitButton label="Confirm" type="button" @click="emit('tryConfirm')" />
        </div>
      </template>
    </Card>

    <TSDialog label="Add Template" v-model:visible="addTemplate" v-if="addTemplate" icon="plus" size="w-[500px]!">
      <template #content>
        <div class="flex flex-col gap-2">
          <label class="font-bold">Name:</label>
          <InputText v-model="newTemplateName" />
          <Button label="Add" icon="pi pi-check" iconPos="right" @click="emit('newTemplate')" />
          <Button label="Cancel" icon="pi pi-times" iconPos="right" severity="surface" @click="addTemplate = false" />
        </div>
      </template>
    </TSDialog>
  </div>
</template>

<script setup lang="ts">
const selectedTemplate = defineModel<any>("selectedTemplate");
const options = defineModel<any[][]>("options", { required: true });
const addTemplate = defineModel<boolean>("addTemplate", { required: true });
const newTemplateName = defineModel<string>("newTemplateName", { required: true });

interface Props {
  templates: any[];
  modal: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  templateChanged: [];
  saveTemplate: [];
  deleteTemplate: [];
  setDefault: [];
  optionsChanged: [];
  newTemplate: [];
  tryConfirm: [];
}>();
</script>
